"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameError = exports.NotApplicableError = exports.NumericError = exports.FunctionSignatureError = exports.ReservedKeywordError = exports.TypeMismatchError = void 0;
var formatter_1 = require("../types/formatter");
/**
 * An error thrown when an operator is applied to a type of value it does not accept.
 */
var TypeMismatchError = /** @class */ (function (_super) {
    __extends(TypeMismatchError, _super);
    function TypeMismatchError(message) {
        var _this = _super.call(this, message !== null && message !== void 0 ? message : "#VALUE!") || this;
        Object.setPrototypeOf(_this, TypeMismatchError.prototype);
        return _this;
    }
    Object.defineProperty(TypeMismatchError.prototype, "errorValue", {
        get: function () {
            return "#VALUE!";
        },
        enumerable: false,
        configurable: true
    });
    return TypeMismatchError;
}(Error));
exports.TypeMismatchError = TypeMismatchError;
/**
 * An error thrown when a function or variable is registered/looked-up with a name that is reserved by the engine.
 * @see Parser.reservedIdentifiers
 */
var ReservedKeywordError = /** @class */ (function (_super) {
    __extends(ReservedKeywordError, _super);
    function ReservedKeywordError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ReservedKeywordError.prototype);
        return _this;
    }
    return ReservedKeywordError;
}(Error));
exports.ReservedKeywordError = ReservedKeywordError;
/**
 * An error thrown when a function is called with a set of parameters that do not match the types its
 * registered signature expects.
 */
var FunctionSignatureError = /** @class */ (function (_super) {
    __extends(FunctionSignatureError, _super);
    function FunctionSignatureError(validationErrors) {
        var _this = this;
        var str = "";
        for (var i = 0; i < validationErrors.length; i++) {
            str += validationErrors[i].message;
            if (i !== validationErrors.length - 1) {
                str += "\n";
            }
        }
        _this = _super.call(this, str) || this;
        Object.setPrototypeOf(_this, FunctionSignatureError.prototype);
        return _this;
    }
    return FunctionSignatureError;
}(TypeMismatchError));
exports.FunctionSignatureError = FunctionSignatureError;
/**
 * An error that is thrown at evaluation-time when the parameters provided at the call-site of an overloaded function
 * cannot be matched to a single, concrete overload (either because no overloads are suitable, or because multiple are).
 */
var OverloadedFunctionSignatureValidationError = /** @class */ (function (_super) {
    __extends(OverloadedFunctionSignatureValidationError, _super);
    function OverloadedFunctionSignatureValidationError(attempts, matchedMultiple) {
        var _this = this;
        var str;
        if (matchedMultiple) {
            str = "Multiple overload signatures matched the provided parameter types. The following overloads matched:\n";
        }
        else {
            str = "No overload signature matched the provided parameter types. The following overloads were attempted:\n";
        }
        for (var i = 0; i < attempts.length; i++) {
            // the signature should always be present, if it isn't, then an overload does match and this error should not be constructed
            var signature = attempts[i].resolvedOverload.signature;
            str += "  Overload #" + (i + 1) + ": " + signature.parameters.map(formatter_1.formatType).join(", ");
            var errors = attempts[i].errors;
            if (errors.length > 0) {
                str += "\n";
            }
            for (var j = 0; j < errors.length; j++) {
                str += "    ";
                if (errors[j].parameterIndex !== undefined) {
                    str += "Parameter #" + (errors[j].parameterIndex + 1) + ": ";
                }
                str += errors[j].message;
                if (j !== errors.length - 1) {
                    str += "\n";
                }
            }
            if (i !== attempts.length - 1) {
                str += "\n";
            }
        }
        _this = _super.call(this, str) || this;
        Object.setPrototypeOf(_this, OverloadedFunctionSignatureValidationError.prototype);
        return _this;
    }
    Object.defineProperty(OverloadedFunctionSignatureValidationError.prototype, "errorValue", {
        get: function () {
            return "#ERROR!";
        },
        enumerable: false,
        configurable: true
    });
    return OverloadedFunctionSignatureValidationError;
}(Error));
exports.default = OverloadedFunctionSignatureValidationError;
/**
 * An error thrown when a function is passed a value that it cannot convert to a number, or a number that is not permissible.
 */
var NumericError = /** @class */ (function (_super) {
    __extends(NumericError, _super);
    function NumericError() {
        var _this = _super.call(this, "#NUM!") || this;
        Object.setPrototypeOf(_this, NumericError.prototype);
        return _this;
    }
    Object.defineProperty(NumericError.prototype, "errorValue", {
        get: function () {
            return "#NUM!";
        },
        enumerable: false,
        configurable: true
    });
    return NumericError;
}(Error));
exports.NumericError = NumericError;
/**
 * An error thrown when a function is cannot provide a result based on the parameters provided.
 */
var NotApplicableError = /** @class */ (function (_super) {
    __extends(NotApplicableError, _super);
    function NotApplicableError() {
        var _this = _super.call(this, "#N/A") || this;
        Object.setPrototypeOf(_this, NotApplicableError.prototype);
        return _this;
    }
    Object.defineProperty(NotApplicableError.prototype, "errorValue", {
        get: function () {
            return "#N/A";
        },
        enumerable: false,
        configurable: true
    });
    return NotApplicableError;
}(Error));
exports.NotApplicableError = NotApplicableError;
/**
 * An error thrown when a formula attempts to use a value or function that is not known.
 */
var NameError = /** @class */ (function (_super) {
    __extends(NameError, _super);
    function NameError() {
        var _this = _super.call(this, "#NAME?") || this;
        Object.setPrototypeOf(_this, NameError.prototype);
        return _this;
    }
    Object.defineProperty(NameError.prototype, "errorValue", {
        get: function () {
            return "#NAME?";
        },
        enumerable: false,
        configurable: true
    });
    return NameError;
}(Error));
exports.NameError = NameError;
//# sourceMappingURL=evaluationErrors.js.map